import { Box, Grid } from "@mui/material";
import React from "react";
import Title from "../../components/title";
import { skills } from "./skill-list";
import "./skill.scss";

let key = 0;
const SKills = () => {
  return (
    <Box sx={{ mt: 5 }}>
      <Title title="My Skills" />

      <Box>
        <Grid sx={{ mt: 5 }} container spacing={2}>
          {skills.map((skill) => (
            <Grid
              sx={{ my: 2 }}
              className="text-center flex justify-center"
              item
              key={key++}
            >
              <span className="skill p-8 text-center">
                <Box className="flex justify-center">
                  <img className="text-center" src={skill.img} alt="" />
                </Box>

                <p className="text-white font-medium mt-2">{skill.name}</p>
              </span>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default SKills;
